/* eslint-disable no-param-reassign */
// node modules
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector, useDispatch } from 'react-redux';

// app modules: actions
import { openOvenMenu } from 'actions/avatarMenu';

// app modules: components
import Button from 'components/Button';
import { ListItem, UnorderedList } from 'components/List';
import ThemedImage from 'components/ThemedImage';

// constants
import { CLASSIFICATION_TYPES } from 'constants/content';

// assets
import CssCategoryPills from './CategoryPills.scss';

function CategoryPills(props) {
  const { backText, categories, onClick } = props;
  useStyles(CssCategoryPills);
  const dispatch = useDispatch();
  const homeConnectEnabled = useSelector(state => state.user.home_connect_enabled);

  if (categories?.length) {
    return (
      <div className="category-pills">
        <UnorderedList className="category-pills__list" inline spaceBetween="none">
          {categories.map(category => {
            if (category.type === CLASSIFICATION_TYPES.HOME_CONNECT) {
              if (homeConnectEnabled) {
                return (
                  <ListItem className="category-pills__item" key="homeconnect">
                    <Button
                      onClick={() => dispatch(openOvenMenu())}
                      className="category-pills__button"
                      size="medium"
                    >
                      <ThemedImage
                        image="images/hclogo.png"
                        darkImage="images/hclogo_white_text.png"
                        height={23}
                        alt="Home Connect"
                      />
                    </Button>
                  </ListItem>
                );
              }
              return null;
            }
            return (
              <ListItem className="category-pills__item" key={category.title}>
                <Button
                  href={category.href}
                  onClick={() => onClick(category)}
                  className="category-pills__button"
                  themeType="outline"
                  themeName="energized"
                  size="medium"
                  referrer={backText}
                >
                  {category.title}
                </Button>
              </ListItem>
            );
          })}
        </UnorderedList>
      </div>
    );
  }
  return null;
}

CategoryPills.propTypes = {
  backText: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
};

CategoryPills.defaultProps = {
  backText: null,
  categories: [],
  onClick: () => {},
};

export default React.memo(CategoryPills);
